import { render, staticRenderFns } from "./TaskC.vue?vue&type=template&id=6ae8d11f&scoped=true"
import script from "./TaskC.vue?vue&type=script&lang=ts"
export * from "./TaskC.vue?vue&type=script&lang=ts"
import style0 from "./TaskC.vue?vue&type=style&index=0&id=6ae8d11f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae8d11f",
  null
  
)

export default component.exports